setAppInteractedCheck